var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 24,
    height: 16,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillRule: "evenodd",
    d: "M13.0593872.0743103c3.15130616.45019532 5.67407227 2.84262085 6.29058839 5.96569824 2.6807251.18630982 4.73162841 2.4635315 4.63726806 5.14907837C23.89282227 13.87466431 21.68719482 16.00231934 19 16H6C2.82849121 15.97860718.22143555 13.49261475.0493164 10.32574463-.12280272 7.15884399 2.1994629 4.40496826 5.3499756 4.04000854 6.81628418 1.21450806 9.90802002-.375885 13.0593872.0743103zM6 14h13c1.61773682.0184021 2.95526123-1.25604248 3.01495361-2.87277222.05963135-1.61672973-1.18029785-2.98632812-2.7949829-3.08724975l-1.52996827-.10998535-.2999878-1.5c-.44970702-2.29098511-2.29986571-4.04653931-4.61126708-4.37545777-2.31140137-.32891845-4.57788086.84085083-5.64874268 2.91546631l-.5.94998169-1.07000732.11001587c-2.08978272.25619507-3.62322998 2.0885315-3.50720215 4.19076538C2.16888428 12.32299805 3.89471436 13.97537231 6 14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillRule: "evenodd",
    d: "M8 9h2.55v3h2.9V9H16l-4-4-4 4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.6db9af6cfbb3cc3d0633056d5351a0e9.svg";
export { ForwardRef as ReactComponent };